// extracted by mini-css-extract-plugin
export default {"-large":"aq_Agp5bbEeSXI5rXM5P","websiteLink":"meGNzcfQKgVDoygPMzTe","linkError":"Ahy07e3917Tl5Ij9hkYh","noBorder":"dQQkJZDjtWdG0vhUv50I"};